import RoundingConfigData from './rounding-config-data';

export default class RoundingConfig {
  data: RoundingConfigData;
  hideToggle: boolean = false;
  constructor(data: Partial<RoundingConfig>) {
    Object.assign(this, data);
  }
}
